import { Star, ShieldCheck, HeartHandshake, BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BBB_URL, BBB_SEAL } from "@/lib/images";

const ITEMS = [
  {
    icon: Star,
    title: "5+ Years of Care",
    text: "Serving Calgary families since 2020",
    testid: "trust-years",
  },
  {
    icon: ShieldCheck,
    title: "Vetted & Insured",
    text: "Background-checked companions",
    testid: "trust-insured",
  },
  {
    icon: HeartHandshake,
    title: "Locally Owned",
    text: "Proudly Calgary owned & operated",
    testid: "trust-local",
  },
];

export const TrustBand = () => (
  <section className="mx-auto max-w-7xl px-4 pt-16 sm:px-6 lg:px-8" data-testid="trust-band">
    <Reveal>
      <div className="grid items-center gap-8 rounded-3xl border border-espresso/10 bg-white p-8 shadow-sm sm:grid-cols-2 sm:p-10 lg:grid-cols-4">
        <a
          href={BBB_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="trust-bbb-link"
          className="group flex items-center justify-center gap-4 rounded-2xl p-2 transition-colors"
        >
          <img
            src={BBB_SEAL}
            alt="Off Our Rockers Seniors Care BBB Business Review"
            className="h-14 w-auto transition-transform duration-300 group-hover:-translate-y-0.5"
            loading="lazy"
          />
          <span className="text-base font-semibold leading-snug text-espresso transition-colors group-hover:text-brand">
            <BadgeCheck className="mb-1 inline h-5 w-5 text-brand" />
            <br />
            BBB Business Profile
          </span>
        </a>
        {ITEMS.map((item) => (
          <div key={item.title} data-testid={item.testid} className="flex items-center justify-center gap-4 p-2 text-left">
            <div className="rounded-2xl bg-brand-soft p-3.5">
              <item.icon className="h-7 w-7 text-brand" />
            </div>
            <div>
              <p className="font-serif text-lg font-semibold text-espresso">{item.title}</p>
              <p className="text-sm text-warmgray">{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </Reveal>
  </section>
);
